// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"cb4066b6","453":"7af34912","555":"3174f8df","767":"1e950e2e","833":"6549ebbc","920":"f13a9002","937":"bc7de705"}[chunkId] + ".chunk.js";
};